import * as React from 'react';

import { translate } from '~l10n/client';

interface QuizResultsViewProps {
  score: number;
  percent: number;
  neutral: number;
  okClicked: () => void;
}

const QuizResultsView = ({
  score,
  percent,
  neutral,
  okClicked,
}: QuizResultsViewProps) => {
  return (
    <div className="modal open">
      <div id="results-container" className="modal-dialog">
        <div className="modal-header">
          <div className="results-title-bar">
            <h3>{translate('Finished!')}</h3>
          </div>
        </div>
        <div className="modal-body">
          <span key="bodyChildren-span-1">
            <b>{translate('Score:')}</b>
            <span className="result-value">{score}</span>
          </span>
          <div key="bodyChildren-div-1" id="percent-text">
            <b>{translate('Percent:')} </b>
            <span className="result-value"> {percent}</span>
          </div>
          {neutral ? (
            <span key="bodyChildren-span-2" id="neutral-text">
              <b>{translate('Non-gradable questions:')} </b>
              <span className="result-value">{neutral}</span>
            </span>
          ) : null}
        </div>
        <div className="modal-footer">
          <button
            className="button button-large button-primary"
            onClick={okClicked}
          >
            {translate('OK')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizResultsView;
